import dispatcher from 'js/core/dispatcher';
import { setUserInfo_v1 } from 'js/library/utils/API/setUserInfo_v1';
import { preferentialAddress } from 'js/library/utils/API/preferentialAddress';
import { findIndexInArray } from 'js/library/utils/helpers.js';

export const editUserInfoAction = (dispatch, uId, newAliasName, newEmail, newGender, newBirthDate, newFullAddress, newAddressExtra, newAddressNumber, newAddressType, userInfoModel, optin) => {
    
    //convertender data de nascimento
    let birthDate = newBirthDate.split('/');
    birthDate = new Date(parseInt(birthDate[2], 10), parseInt(birthDate[1] - 1, 10), parseInt(birthDate[0], 10), 0, 0).getTime();
    
    //adicionar endereço
    newFullAddress['extra'] = newAddressExtra;
    newFullAddress['number'] = newAddressNumber;
    newFullAddress['type'] = newAddressType;

    //adicionando email
    const emailIndex = findIndexInArray(userInfoModel.contactList, 'type', 'email');

    if (emailIndex !== null) {
        userInfoModel.contactList[emailIndex].value = newEmail;
    }
    else {
        userInfoModel.contactList.push({ type: 'email', value: newEmail });
    }

    //adicionando endereço
    const addressIndex = findIndexInArray(userInfoModel.contactList, 'type', newAddressType);

    if (addressIndex !== null) {
        userInfoModel.addressList[addressIndex] = newFullAddress;
    }
    else {
        userInfoModel.addressList = [newFullAddress];
    }

    //tratando optin
    let optInList = [];
    const currentDate = new Date().getTime();

    if(Array.isArray(userInfoModel.optInList)) {
        const i = findIndexInArray(userInfoModel.optInList, 'optInId', '-KzjMOHvzce-PUYpoWHU');
        optInList = userInfoModel.optInList;
        
        if (i === null) {
            optInList.push({
                'type': 'Optin - Termos de consentimento de comunicações opcionais',
                'optInId': '-KzjMOHvzce-PUYpoWHU',
                'version': 1.0,
                'dateAcceptance': currentDate,
                'accept': optin
            });
        }
        else {
            userInfoModel.optInList[i].accept = optin;
        }
    }
    else {
        optInList.push({
            'type': 'Optin - Termos de consentimento de comunicações opcionais',
            'optInId': '-KzjMOHvzce-PUYpoWHU',
            'version': 1.0,
            'dateAcceptance': currentDate,
            'accept': optin
        });
    }

    const userInfo = {
        uId,
        aliasName: newAliasName,
        'updateDate': new Date().getTime(),
        'syncType': 'merge',
        addressList: userInfoModel.addressList,
        contactList: userInfoModel.contactList,
        birthDate,
        optInList,
        gender: parseInt(newGender, 10)
    };

    const origin = 'user';
    
    return dispatcher(dispatch, 'EDIT_USER_INFO', setUserInfo_v1(uId, ['setUserInfo'], userInfo, null), preferentialAddress(uId, origin, newAddressType, newFullAddress.zipCode) );
};